import React, {useEffect, useState} from "react";
import {RootState} from "../model";
import {connect} from "react-redux";
import Template from "./Template";
import {useActions} from "../redux/actions";
import * as reportsActions from "../redux/actions/reports";
import {Button, Checkbox, Confirm, Dropdown, List, Menu, Pagination, Popup, Table} from "semantic-ui-react";
import moment from "moment";
import * as practiceActions from "../redux/actions/practice";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import * as usersActions from "../redux/actions/users";
import * as adjustmentsActions from "../redux/actions/adjustments";


interface Props {
    PracticeList: any
}

function UsageReport(props: Props) {
    const pageLimit = 50;
    const filterInit: any = {
        practices: [],
        status: [],
        date: null
    }
    const initialState: any = {
        report: [],
        selectedRows: []
    }
    const initPaging = {
        activePage: 1,
        totalCount: 1
    }
    const reportsAction = useActions(reportsActions)
    const practiceAction = useActions(practiceActions);
    const UsersActions = useActions(usersActions);
    const AdjustmentsActions = useActions(adjustmentsActions);
    const [activeTab, setActiveTab] = useState<'users' | 'adjustments'>('users');
    const [state, setState] = useState(initialState);
    const [date, setDate] = useState(null);
    const [practiceOpts, setPracticeOpts] = useState([])
    const [filters, setFilters] = useState(filterInit);
    const [confirmReRun, setConfirmReRun] = useState(false)
    const [confirmAcknowledge, setConfirmAcknowledge] = useState(false)
    const [paging, setPaging] = useState(initPaging);

    const {PracticeList} = props;
    useEffect(() => {
        if (PracticeList && !PracticeList.length) {
            practiceAction.getAllPractices().then((res: any) => {
                preparePracticeOptions(res);
            });
        } else {
            preparePracticeOptions(PracticeList);
        }
    }, []);

    useEffect(() => {
        loadReport(filters, paging.activePage);
    }, [filters, paging.activePage, activeTab]);

    const preparePracticeOptions = (list: any) => {
        const options: any = [];
        list.forEach((item: any) => {
            options.push({text: item.practice.practice, value: item.practiceId, key: item.practiceId})
        })
        setPracticeOpts(options)
    }

    const loadReport = (filters: any, activePage: number) => {
        const fetchFn = activeTab === 'adjustments'
            ? AdjustmentsActions.getAdjustmentApiUsage
            : reportsAction.getUsage;

        fetchFn({...filters, page: activePage}).then((data: any) => {
            const rows = data?.rows ?? [];
            const count = data?.count ?? 0;
            setState({...state, report: rows})
            setPaging(prevState => ({...prevState, totalCount: count}))
        });
    }

    const handleReRun = () => {
        const {selectedRows} = state;
        setConfirmReRun(false)
        if (selectedRows && !selectedRows.length) {
            alert('Please select at least one row.');
            return false;
        }
        const launchFn = activeTab === 'adjustments'
            ? AdjustmentsActions.launchFailedAdjustmentRequests
            : UsersActions.launchFailedRequests;
        launchFn({ids: selectedRows}).then((res: any) => {
            alert(res.message);
        })
    }

    const onChangeDate = (dateInfo: any) => {
        const finalDate: any = dateInfo ? moment(dateInfo).format('YYYY-MM-DD') : null;
        setFilters({...filters, date: finalDate});
        setDate(dateInfo);
    };

    const handleCheckAll = (checked: boolean | undefined) => {
        const reportData = getFilteredReport('checkBox');
        return reportData.forEach((item: any) => handleCheckBox(checked, item.id));
    }

    const handlePaginationChange = (page: any) => {
        setPaging({...paging, activePage: page})
    }


    const handleCheckBox = (checked: any, id: number) => {
        const selectedRows: any = state.selectedRows;
        if (checked) {
            if (!selectedRows.includes(id))
                selectedRows.push(id);
        } else {
            const index = selectedRows.indexOf(id);
            selectedRows.splice(index, 1);
        }
        setState({...state, selectedRows});
    };

    const handleMarkAcknowledge = () => {
        setConfirmAcknowledge(false)
        const {selectedRows} = state;
        const id = selectedRows
        const updateFn = activeTab === 'adjustments'
            ? AdjustmentsActions.updateAdjustmentApiUsageLogs
            : reportsAction.updateApiUsageLogs;
        updateFn({id, result: 'acknowledged'}).then(() => {
            loadReport(filters, paging.activePage);
        })
    }

    const handleChangeStatus = (idNum: number, value: any) => {
        const id = [idNum]
        const updateFn = activeTab === 'adjustments'
            ? AdjustmentsActions.updateAdjustmentApiUsageLogs
            : reportsAction.updateApiUsageLogs;
        updateFn({id, result: value}).then(() => {
            loadReport(filters, paging.activePage);
        })
    }

    const getFilteredReport = (useCase: string) => {
        const {practices, status} = filters;

        return state.report.filter((item: any) => {
            const practiceMatch = !practices.length || practices.includes(item.practiceId);
            const statusMatch = !status.length || status.some((s: string) => s.toLowerCase() === (item.result || '').toLowerCase());
            const areaMatch = useCase !== 'checkBox' || item.result === 'failed';
            return practiceMatch && statusMatch && areaMatch;
        });
    };

    const handleTabChange = (tab: 'users' | 'adjustments') => {
        setActiveTab(tab);
        setState(initialState);
        setPaging(initPaging);
    }

    const generateReport = (report: any) => {
        return report && report.map((item: any) => {
            const itemData = item.data || {}
            if (activeTab === 'adjustments') {
                return (
                    <Table.Row key={item.id}>
                        <Table.Cell> {item.result === 'failed' ? <Checkbox
                            key={item.id}
                            value={item.id}
                            className='mr10'
                            checked={state.selectedRows.includes(item.id)}
                            onChange={(e, {checked}) => handleCheckBox(checked, item.id)}
                        /> : ''}</Table.Cell>
                        <Table.Cell>{item.user ? item.user.firstname + ' ' + item.user.lastname : '—'}</Table.Cell>
                        <Table.Cell>{item.practice ? item.practice.practice : '—'}</Table.Cell>
                        <Table.Cell>{item.action}</Table.Cell>
                        <Table.Cell>{itemData.ItemName || '—'}</Table.Cell>
                        <Table.Cell>{itemData.DefNum || '—'}</Table.Cell>
                        <Table.Cell>{moment(item.createdAt).format('MM-DD-YYYY hh:mm:ss A')}</Table.Cell>
                        <Table.Cell> <Popup
                            trigger={<Button icon={'eye'} content={itemData.ItemName || 'View'}/>}
                            content={<List>
                                {Object.entries(itemData).filter(([key]) => key !== 'oldValues').map(([key, value]: [any, any]) => (
                                    <List.Item key={key}><strong>{key}:</strong> {value != null ? (Array.isArray(value) ? value.join(', ') : String(value)) : '—'}</List.Item>
                                ))}
                                {itemData.oldValues && (
                                    <>
                                        <List.Item><strong>--- Previous Values ---</strong></List.Item>
                                        {Object.entries(itemData.oldValues).map(([key, value]: [any, any]) => (
                                            <List.Item key={`old-${key}`}><strong>{key}:</strong> {value != null ? String(value) : '—'}</List.Item>
                                        ))}
                                    </>
                                )}
                            </List>}
                            on={['hover', 'click']}
                        /></Table.Cell>
                        <Table.Cell className={'text-uppercase'}>{item.result === 'failed' ? <Dropdown
                            options={[
                                {text: 'Failed', key: 'failed', value: 'failed'},
                                {text: 'Acknowledged', key: 'acknowledged', value: 'acknowledged'}
                            ]}
                            selection={true}
                            value={item.result}
                            onChange={(e, values) => handleChangeStatus(item.id, values.value)}
                        /> : item.result}</Table.Cell>
                        <Table.Cell style={{color: 'red'}}>{item.error || '—'}</Table.Cell>
                    </Table.Row>
                )
            }
            return (
                <Table.Row key={item.id}>
                    <Table.Cell> {item.result === 'failed' ? <Checkbox
                        key={item.id}
                        value={item.id}
                        className='mr10'
                        checked={state.selectedRows.includes(item.id)}
                        onChange={(e, {checked}) => handleCheckBox(checked, item.id)}
                    /> : ''}</Table.Cell>
                    <Table.Cell>{item.user ? item.user.firstname + ' ' + item.user.lastname : '—'}</Table.Cell>
                    <Table.Cell>{item.action}</Table.Cell>
                    <Table.Cell>{item.practice ? item.practice.practice : '—'}</Table.Cell>
                    <Table.Cell>{moment(item.createdAt).format('MM-DD-YYYY hh:mm:ss A')}</Table.Cell>
                    <Table.Cell>{moment(item.updatedAt).format('MM-DD-YYYY hh:mm:ss A')}</Table.Cell>
                    <Table.Cell> <Popup
                        trigger={<Button icon={'eye'}
                                         content={itemData.UserName ? itemData.UserName : itemData.userName}/>}
                        content={<List>
                            {Object.entries(itemData).map(([key, value]: [any, any]) => (
                                <List.Item key={key}><strong>{key}:</strong> {value != null ? (Array.isArray(value) ? value.join(', ') : String(value)) : '—'}</List.Item>
                            ))}
                        </List>}
                        on={['hover', 'click']}
                    /></Table.Cell>
                    <Table.Cell className={'text-uppercase'}>{item.result === 'failed' ? <Dropdown
                        options={[
                            {text: 'Failed', key: 'failed', value: 'failed'},
                            {text: 'Acknowledged', key: 'acknowledged', value: 'acknowledged'}
                        ]}
                        selection={true}
                        value={item.result}
                        onChange={(e, values) => handleChangeStatus(item.id, values.value)}
                    /> : item.result}</Table.Cell>
                </Table.Row>
            )
        })
    }
    const reportData = getFilteredReport('table');
    return (
        <Template activeLink="usage-report">
            <Menu tabular>
                <Menu.Item
                    name='User Logs'
                    active={activeTab === 'users'}
                    onClick={() => handleTabChange('users')}
                />
                <Menu.Item
                    name='Adjustment Logs'
                    active={activeTab === 'adjustments'}
                    onClick={() => handleTabChange('adjustments')}
                />
            </Menu>
            <Confirm
                open={confirmReRun}
                onCancel={() => setConfirmReRun(false)}
                onConfirm={() => handleReRun()}
            />
            <Confirm
                open={confirmAcknowledge}
                onCancel={() => setConfirmAcknowledge(false)}
                onConfirm={() => handleMarkAcknowledge()}
            />
            <div className="ui card">
                <div className="content">
                    <h2 className="float-left mr10">Usage Report ({paging.totalCount})</h2>
                    <div className="topFilters">
                        <Dropdown
                            placeholder='Select Practice'
                            options={practiceOpts}
                            selection={true}
                            search={true}
                            multiple={true}
                            value={filters.practices}
                            onChange={(e, values) => {
                                setFilters({...filters, practices: values.value})
                                setPaging({...paging, activePage: 1})
                            }
                            }
                            name="practice"
                        />
                        <Dropdown
                            placeholder='Select Status'
                            options={[
                                {text: 'Success', key: 'success', value: 'success'},
                                {text: 'Failed', key: 'failed', value: 'failed'},
                                {text: 'Acknowledged', key: 'acknowledged', value: 'acknowledged'}
                            ]}
                            selection={true}
                            search={true}
                            multiple={true}
                            value={filters.status}
                            onChange={(e, values) => {
                                setFilters({...filters, status: values.value})
                                setPaging({...paging, activePage: 1})
                            }
                            }
                            name="practice"
                        />

                        <div className="datePicker">
                            <DatePicker
                                placeholderText={"YYYY-MM-DD"}
                                name="date"
                                className='ui input mb15 mr10'
                                dateFormat="yyyy-MM-dd"
                                selected={date}
                                onChange={(e: any) => onChangeDate(e)}
                                isClearable={true}
                            />
                        </div>
                        <Button onClick={() => setConfirmAcknowledge(true)}> Mark As Acknowledge</Button>
                        <Button onClick={() => setConfirmReRun(true)}> Re-Run Failed</Button>

                    </div>
                </div>
            </div>
            <div className={"ui card"}>
                <Table celled={true}>
                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell>
                                <div>
                                    <Checkbox
                                        className='mr10'
                                        onChange={(e, {checked}) => handleCheckAll(checked)}
                                    />
                                </div>
                            </Table.HeaderCell>
                            {activeTab === 'adjustments' ? (
                                <>
                                    <Table.HeaderCell>User</Table.HeaderCell>
                                    <Table.HeaderCell>Practice</Table.HeaderCell>
                                    <Table.HeaderCell>Action</Table.HeaderCell>
                                    <Table.HeaderCell>ItemName</Table.HeaderCell>
                                    <Table.HeaderCell>DefNum</Table.HeaderCell>
                                    <Table.HeaderCell>Created</Table.HeaderCell>
                                    <Table.HeaderCell>Data</Table.HeaderCell>
                                    <Table.HeaderCell>Status</Table.HeaderCell>
                                    <Table.HeaderCell>Error</Table.HeaderCell>
                                </>
                            ) : (
                                <>
                                    <Table.HeaderCell>User</Table.HeaderCell>
                                    <Table.HeaderCell>Action</Table.HeaderCell>
                                    <Table.HeaderCell>Practice</Table.HeaderCell>
                                    <Table.HeaderCell>Created</Table.HeaderCell>
                                    <Table.HeaderCell>Updated</Table.HeaderCell>
                                    <Table.HeaderCell>Data</Table.HeaderCell>
                                    <Table.HeaderCell>Status</Table.HeaderCell>
                                </>
                            )}
                        </Table.Row>
                    </Table.Header>

                    <Table.Body>
                        {generateReport(reportData)}
                    </Table.Body>
                </Table>
                <Pagination
                    activePage={paging.activePage}
                    onPageChange={(e, {activePage}) => handlePaginationChange(activePage)}
                    totalPages={Math.ceil(paging.totalCount / pageLimit)}
                />
            </div>
        </Template>
    );
}


function mapStateToProps(state: RootState) {
    return {
        PracticeList: state.practice.allPracticeList,
    };
}

export default connect(mapStateToProps)(UsageReport);

